module.exports = "/_next/static/images/icon-enquire-27dcc7f9c8e1f711a30db15509658c1d.png";